'use client'

import { useUpcomingStudioVideosQuery } from '@/generated/graphql'

export const StudioComingSoon = () => {
  const { data } = useUpcomingStudioVideosQuery()

  if (!data?.upComingStudioVideos?.length) {
    return null
  }

  return (
    <section className="mt-12 p-6 md:p-8 bg-[#f2f2f2] rounded-lg">
      <h2 className="text-2xl font-bold mb-2">
        Coming soon to Vanishing Inc. Studio
      </h2>
      <p className="text-lg text-gray-600 mb-6">
        We&apos;re always updating your streaming library. Here&apos;s just a
        preview of what you can look forward to in the future:
      </p>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {data.upComingStudioVideos.map(video => (
          <article
            key={video.urlStub || video.name}
            className="flex flex-col overflow-hidden rounded-md bg-white shadow-sm border border-gray-200"
          >
            <div className="relative w-full aspect-[16/9]">
              <img
                src={video.thumbnailSrc || ''}
                alt={video.name || 'Coming soon'}
                className="h-full w-full object-cover"
              />
              <span className="absolute bottom-2 left-2 rounded bg-black/70 px-2 py-1 text-xs font-medium text-white">
                Coming soon
              </span>
            </div>
            <div className="flex flex-1 flex-col px-6 py-5">
              <h3 className="text-xl font-semibold leading-snug">{video.name}</h3>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
